import { Box, CircularProgress } from '@mui/material';
import { useCurrentEditor } from '@tiptap/react';
import React, { useEffect, useState } from 'react';
import Dropzone from '../utils/common/Dropzone.jsx';

// Composant pour gérer l'initialisation de l'éditeur
const EditorHandler = ({
  // ticket,
  attachments,
  setAttachments,
  attachmentsSize,
  setTotalAttachmentsSize,
  deleteAttachment,
  onFileAdd,
  onEditorReady,
  // mutateTicket,
  // setEditorHasChanged,
}) => {
  const [isEditorLoaded, setIsEditorLoaded] = useState(false);
  const { editor } = useCurrentEditor();

  // const handleEditorBoxMedia = async (file) => {
  //   const cid = uuidv4();
  //   const tempAttachment = {
  //     file: file,
  //     link: URL.createObjectURL(file),
  //     content: null, // Sera rempli après le FileReader
  //     cid: cid,
  //     isAtt: false,
  //     name: file?.name,
  //     size: file?.size,
  //     mimeType: file?.type,
  //     status: 'loading',
  //     alt: file?.name,
  //   };

  //   // Mettre à jour le state immédiatement avec le statut loading
  //   setAttachments((prev) => [...prev, tempAttachment]);

  //   return new Promise((resolve, reject) => {
  //     const fileReader = new FileReader();
  //     fileReader.onloadend = async (e) => {
  //       const content = fileReader.result;
  //       const imgObject = {
  //         ...tempAttachment,
  //         content: content,
  //       };
  //       editor
  //         .chain()
  //         .focus()
  //         .setImage({ src: imgObject?.content, alt: file?.name })
  //         .run();
  //       resolve(imgObject);
  //     };
  //     fileReader.onerror = (error) => {
  //       console.error(error);
  //       // En cas d'erreur, retirer l'attachment du state
  //       setAttachments((prev) => prev.filter((att) => att.cid !== cid));
  //       reject(error);
  //     };
  //     fileReader.readAsDataURL(file);
  //     setTimeout(() => {
  //       setEditorHasChanged(true);
  //     }, 100);
  //   });
  // };

  const handleLoadEditor = (editor) => {
    if (!editor) return;
    editor.setOptions({
      editorProps: {
        handlePaste: (_view, _event) => {
          return;
        },
        handleDrop: (_view, _event) => {
          return;
        },
        // FIXME: l'ajout d'une nouvelle pièce jointe inline supprime les autres pièces jointes
        // handlePaste: async (view, event) =>
        //   await EDITOR_UTILS.handlePaste({
        //     view,
        //     event,
        //     ticket,
        //     attachmentsSize,
        //     onFileAdd,
        //     editor,
        //     setEditorHasChanged,
        //     handleEditorBoxMedia,
        //   }),
        // FIXME: le drop ne fonctionne pas correctement.
        // les images ne sont pas affichées dans l'editeur à la place du curseur
        // mais à la position de la dernière écriture ou en haut de l'éditeur.
        // comportement incohérent à fix avant d'utiliser ceci.
        // handleDrop: async (view, event) =>
        //   await EDITOR_UTILS.handleDrop({
        //     view,
        //     event,
        //     ticket,
        //     attachmentsSize,
        //     onFileAdd,
        //     editor,
        //     handleEditorBoxMedia,
        //     setEditorHasChanged,
        //   }),
      },
    });
    setIsEditorLoaded(true);
    onEditorReady(editor);
  };

  useEffect(() => {
    if (editor && !isEditorLoaded) {
      handleLoadEditor(editor);
    }
  }, [editor, isEditorLoaded]);

  if (!isEditorLoaded) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '30vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Dropzone
      attachments={attachments}
      setAttachments={setAttachments}
      deleteAttachment={deleteAttachment}
      attachmentsSize={attachmentsSize}
      setTotalAttachmentsSize={setTotalAttachmentsSize}
      onFileAdd={onFileAdd}
    />
  );
};

export default EditorHandler;
